type Environment = "dev" | "uat" | "stress" | "prd" | "mock";

let hasDevtools = false;

export function getEnv(): Environment {
  if (process.env.NODE_ENV === "development") {
    window.Devtools = require("@sicredi/dev-tools").default;

    /* istanbul ignore else */
    if (!hasDevtools) {
      window.Devtools.init();
      hasDevtools = true;
    }

    return (
      (window.env?.ENV as Environment) ??
      window.Devtools.currentEnvironment().toLowerCase()
    );
  }

  const matches = window.location.href.match(
    new RegExp(/(dev|uat|stress|prd|)[-|.]sicredi.(in|io|cloud|com.br)/gim)
  );

  if (matches) {
    const checkPRD =
      matches[0] === ".sicredi.io" ||
      matches[0] === ".sicredi.in" ||
      matches[0] === ".sicredi.com.br";

    return checkPRD
      ? "prd"
      : (matches[0].replace(
          /[-|.]sicredi.(in|io|cloud|com.br)/gim,
          ""
        ) as Environment);
  }

  return "dev" as Environment;
}

export function getMockAddress() {
  if (process.env.NODE_ENV === "development") {
    window.Devtools = window.Devtools || require("@sicredi/dev-tools").default;
    return window.Devtools.mockAddress();
  }

  return "";
}
